module.exports = __webpack_public_path__ + "img/donante-steren-tijuana.76d828de.jpg";